import { Answer } from "./answer";
import { Contact } from "./contact";
import { Note } from "./note";
import { DEFAULT_REGION } from "./sentinels";
export class ReferenceContact {
    constructor() {
        this.id = undefined;
        this.contactEntity = new Contact();
        this.tenantId = null;
        this.ownerId = null;
        this.notes = [];
        this.draftNote = "";
        this.summary = "";
        this.dateAdded = new Date();
        this.updatedAt = new Date();
        this.createdBy = "";
        this.updatedBy = "";
        this.businessId = undefined;
        this.regions = [];
        this.answers = [];
        this.communityId = undefined;
        this.userProfileId = undefined;
    }
    static empty() {
        const result = new ReferenceContact();
        return result;
    }
    clone() {
        return ReferenceContact.clone(this);
    }
    static clone(source) {
        const theClone = new ReferenceContact();
        theClone.id = source.id;
        theClone.contactEntity = Contact.load(source.contactEntity || {});
        theClone.notes = (source.notes || []).map((n) => Note.clone(n));
        theClone.draftNote = source.draftNote;
        theClone.summary = source.summary;
        theClone.tenantId = source.tenantId;
        theClone.businessId = source.businessId;
        theClone.regions = (source.regions || []).slice();
        if (theClone.regions.length === 0) {
            theClone.regions = [DEFAULT_REGION];
        }
        theClone.ownerId = source.ownerId ?? null;
        theClone.dateAdded = source.dateAdded ? new Date(source.dateAdded) : new Date();
        theClone.updatedAt = source.updatedAt ? new Date(source.updatedAt) : new Date();
        theClone.updatedBy = source.updatedBy;
        theClone.createdBy = source.createdBy;
        theClone.answers = (source.answers || []).map((a) => Answer.clone(a));
        theClone.communityId = source.communityId;
        return theClone;
    }
    static load(source) {
        const theClone = new ReferenceContact();
        theClone.id = source.id;
        theClone.contactEntity = Contact.load(source.contactEntity || {});
        theClone.notes = (source.notes || []).map((n) => Note.load(n));
        theClone.draftNote = source.draftNote;
        theClone.summary = source.summary;
        theClone.businessId = source.businessId;
        theClone.tenantId = source.tenantId;
        theClone.regions = (source.regions || []).slice();
        if (theClone.regions.length === 0) {
            theClone.regions = [DEFAULT_REGION];
        }
        theClone.ownerId = source.ownerId ?? null;
        theClone.dateAdded = source.dateAdded;
        theClone.updatedAt = source.updatedAt;
        theClone.updatedBy = source.updatedBy;
        theClone.createdBy = source.createdBy;
        theClone.answers = (source.answers || []).map((a) => Answer.load(a));
        theClone.communityId = source.communityId;
        return theClone;
    }
    get preferredName() {
        return this.contactEntity?.name?.trim() || "(no name)";
    }
    matches(matchText) {
        return this.preferredName.toLowerCase().indexOf(matchText) >= 0;
    }
}
//# sourceMappingURL=reference-contact.js.map